import { Button } from './ui/button'
import './ui/avatar';
import { ChevronRight, ArrowLeft } from 'lucide-react';

export function Header({
    theme,
    currentScreen,
    showChatPanel,
    onScreenChange,
    onThemeToggle,
    onChatToggle,
    isImageFlow,
    showPerformanceStep,
    isEditing,
    maxStepReached
}) {
    const allSteps = [
        { key: "brand-profile", label: "Brand" },
        { key: "marketing-plan", label: "Plan" },
        { key: "ad-concepts", label: "Concepts" },
        { key: "generate-ads", label: "Script & Visuals" },
        { key: "creatives", label: "Creative" },
        { key: "performance", label: "Performance" },
    ]
    const steps = allSteps.filter(s => {
        if (s.key === "generate-ads" && (isImageFlow || (isEditing && currentScreen !== "generate-ads"))) return false
        if (s.key === "performance" && !showPerformanceStep && currentScreen !== "performance") return false
        return true
    })

    const showNav = currentScreen !== "cmo-overview" && currentScreen !== "brand-analysis"
    allSteps.findIndex(s => s.key === currentScreen);

    if (!showNav) {
        return <></>
    }

    return (
        <header
            className="marketing-header h-16 border-b flex items-center justify-between px-6 border-gray-200 bg-white dark:border-white/5 dark:bg-[#111111]"
        >
            <div className="flex min-w-0 max-w-full items-center gap-2">
                <Button 
                    variant="ghost" 
                    size="icon" 
                    onClick={() => onScreenChange('cmo-overview')}
                    className="mr-2 rounded-xl transition-all text-gray-600 hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-white/5"
                >
                    <ArrowLeft className="w-5 h-5" />
                </Button>
                <div className="h-6 w-px mr-2 bg-gray-200 dark:bg-white/10"></div>
                <nav className="marketing-header__steps flex items-center gap-1">
                    {steps.map((step) => {
                        const stepIndex = allSteps.findIndex(s => s.key === step.key);
                        const isStepDisabled = !isEditing && stepIndex > maxStepReached;


                        return (
                            <div key={step.key} className="flex items-center">
                                <button
                                    disabled={isStepDisabled}
                                    onClick={() => onScreenChange(step.key)}
                                    className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-all ${
                                        currentScreen === step.key
                                            ? 'bg-orange-500 text-white shadow-sm cursor-default'
                                            : isStepDisabled
                                                ? 'text-gray-400 dark:text-gray-600 cursor-not-allowed opacity-60'
                                                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-white/5 cursor-pointer'
                                    }`}
                                >
                                    {step.label}
                                </button>
                                {step.key !== steps[steps.length - 1].key && (
                                    <ChevronRight className="w-4 h-4 mx-1 text-gray-400 dark:text-gray-600" />
                                )}
                            </div>
                        );
                    })}
                </nav>
            </div>
        </header>
    )
}
